// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../../../../graphql/__generated__/types';

const defaultOptions = {} as const;
export type GetDashboardEmployeeAlertQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetDashboardEmployeeAlertQuery = { __typename?: 'Query' } & {
  listEmployeeAlertsByCountry: { __typename?: 'ListEmployeeAlertsByCountry' } & {
    countByPriority: { __typename?: 'EmployeeAlertCountByPriority' } & Pick<
      Types.EmployeeAlertCountByPriority,
      'high' | 'medium' | 'low'
    >;
  };
};

export const GetDashboardEmployeeAlertDocument = /*#__PURE__*/ gql`
    query getDashboardEmployeeAlert {
  listEmployeeAlertsByCountry {
    countByPriority {
      high
      medium
      low
    }
  }
}
    `;

/**
 * __useGetDashboardEmployeeAlertQuery__
 *
 * To run a query within a React component, call `useGetDashboardEmployeeAlertQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardEmployeeAlertQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardEmployeeAlertQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDashboardEmployeeAlertQuery(
  baseOptions?: Apollo.QueryHookOptions<GetDashboardEmployeeAlertQuery, GetDashboardEmployeeAlertQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDashboardEmployeeAlertQuery, GetDashboardEmployeeAlertQueryVariables>(
    GetDashboardEmployeeAlertDocument,
    options,
  );
}
export function useGetDashboardEmployeeAlertLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardEmployeeAlertQuery, GetDashboardEmployeeAlertQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDashboardEmployeeAlertQuery, GetDashboardEmployeeAlertQueryVariables>(
    GetDashboardEmployeeAlertDocument,
    options,
  );
}
// @ts-expect-error
export function useGetDashboardEmployeeAlertSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDashboardEmployeeAlertQuery,
    GetDashboardEmployeeAlertQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetDashboardEmployeeAlertQuery, GetDashboardEmployeeAlertQueryVariables>;
export function useGetDashboardEmployeeAlertSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetDashboardEmployeeAlertQuery, GetDashboardEmployeeAlertQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetDashboardEmployeeAlertQuery | undefined, GetDashboardEmployeeAlertQueryVariables>;
export function useGetDashboardEmployeeAlertSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetDashboardEmployeeAlertQuery, GetDashboardEmployeeAlertQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetDashboardEmployeeAlertQuery, GetDashboardEmployeeAlertQueryVariables>(
    GetDashboardEmployeeAlertDocument,
    options,
  );
}
export type GetDashboardEmployeeAlertQueryHookResult = ReturnType<typeof useGetDashboardEmployeeAlertQuery>;
export type GetDashboardEmployeeAlertLazyQueryHookResult = ReturnType<typeof useGetDashboardEmployeeAlertLazyQuery>;
export type GetDashboardEmployeeAlertSuspenseQueryHookResult = ReturnType<
  typeof useGetDashboardEmployeeAlertSuspenseQuery
>;
